"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    reopenModal: {
        reopenHeading: 'Reopen',
        fetchingInformation: 'Fetching Information, please wait a second',
        reopenButton: 'REOPEN',
        allStudents: 'All Students',
        reopenSuccess: '{{assessmentName}} has been reopened to students',
        assessmentReopenedTo: 'Assessment will be reopened to {{studentCount}} {{student}}.',
        equipAssessmentWarning: 'Selected student(s) will be able to re-submit. Original answers cannot be changed',
        nonEquipAssessmentWarning: 'Selected student(s) will be able to re-submit. Their original answers will be retained and can be modified',
        labelAllStudents: 'select all {{totalStudents}} students checkbox',
        labelStudent: '{{name}} checkbox',
        ok: 'Ok',
    },
};
